import React from 'react';
import * as Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import ActualParticipants from './ActualParticipants';
import ParticipationRate from './ParticipationRate';
import NotReaders from './NotReaders';
import WeakReaders from './WeakReaders';
import NonReadersChart from './NonReadersChart';
import WeakReadersChart from './WeakReadersChart';
import {ISubmissionsUoaData} from '../utils/data';

require('highcharts/modules/exporting')(Highcharts);
HighchartsMore(Highcharts);

const AllProjects = ({iniziativaSubmissions, beneficiarySubmissions, uoaParentId}: ISubmissionsUoaData) => {
    const iniziativa = iniziativaSubmissions.find((submission) => submission.uoa_id === uoaParentId);
    const type = iniziativa?.proj_type || null;
    const typeIniziativaSubmissions = iniziativaSubmissions.filter((submission) => submission.proj_type === type)

    return (
        <>
            <div className='w-full'>
                <div className='section-title'>
                    <div>Statistiche benchmark (comparazione con tutte le iniziative di questo tipo)</div>
                </div>

                <div className='container-child grid-cols-2'>
                    <div className='chart-container'>
                        {
                            (typeIniziativaSubmissions && beneficiarySubmissions) && (
                                <>
                                    <ActualParticipants
                                        iniziativaSubmissions={typeIniziativaSubmissions}
                                        beneficiarySubmissions={beneficiarySubmissions}
                                    />
                                    <ParticipationRate
                                        iniziativaSubmissions={typeIniziativaSubmissions}
                                        beneficiarySubmissions={beneficiarySubmissions}
                                    />
                                </>
                            )
                        }
                    </div>

                    <div className='chart-container'>
                        {
                            (typeIniziativaSubmissions && beneficiarySubmissions) && (
                                <>
                                    <NotReaders
                                        iniziativaSubmissions={typeIniziativaSubmissions}
                                        beneficiarySubmissions={beneficiarySubmissions}
                                    />
                                    <WeakReaders
                                        iniziativaSubmissions={typeIniziativaSubmissions}
                                        beneficiarySubmissions={beneficiarySubmissions}
                                    />
                                </>
                            )
                        }
                    </div>
                </div>

                <div className='container-child grid-cols-2 mt-12'>
                    {
                        (typeIniziativaSubmissions && beneficiarySubmissions && uoaParentId) && (
                            <>
                                <NonReadersChart
                                    iniziativaSubmissions={typeIniziativaSubmissions}
                                    beneficiarySubmissions={beneficiarySubmissions}
                                    uoaParentId={uoaParentId}
                                />
                                <WeakReadersChart
                                    iniziativaSubmissions={typeIniziativaSubmissions}
                                    beneficiarySubmissions={beneficiarySubmissions}
                                    uoaParentId={uoaParentId}
                                />
                            </>
                        )
                    }
                </div>
            </div>
        </>
    );
};

export default AllProjects;
